import tseInstance from '../instance'

const createTseNullOrder = (date) => {
  return tseInstance.post('/nullOrders', { date })
}

export default createTseNullOrder
